export enum Orientation {
	LANDSCAPE = 0,
	LANDSCAPE_FLIPPED = 1,
}
